<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_2421_5315)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.93242 8.00065C1.93242 4.65013 4.64856 1.93399 7.99909 1.93399C11.3496 1.93399 14.0658 4.65013 14.0658 8.00065C14.0658 11.3512 11.3496 14.0673 7.99909 14.0673C4.64856 14.0673 1.93242 11.3512 1.93242 8.00065ZM7.99909 0.733986C3.98582 0.733986 0.732422 3.98738 0.732422 8.00065C0.732422 12.0139 3.98582 15.2673 7.99909 15.2673C12.0124 15.2673 15.2658 12.0139 15.2658 8.00065C15.2658 3.98738 12.0124 0.733986 7.99909 0.733986ZM8.60039 5.33447C8.60039 5.0031 8.33176 4.73447 8.00039 4.73447C7.66902 4.73447 7.40039 5.0031 7.40039 5.33447V8.00114C7.40039 8.20175 7.50065 8.38909 7.66757 8.50037L9.66757 9.8337C9.94329 10.0175 10.3158 9.94301 10.4996 9.66729C10.6834 9.39158 10.6089 9.01905 10.3332 8.83524L8.60039 7.68003V5.33447Z"
                fill="#9A9A9A"
            />
        </g>
        <defs>
            <clipPath id="clip0_2421_5315">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script>
export default {
    data() {
        return {};
    },
};
</script>
